var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 406.158,
    height: 512,
    viewBox: "0 0 406.158 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-363 -395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(597 734.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M154.043,45.3a7.172,7.172,0,0,0-3.333,9.58,71,71,0,0,1,7.1,31.2A71.732,71.732,0,1,1,86.079,14.346a70.87,70.87,0,0,1,44.532,15.476,7.172,7.172,0,1,0,8.926-11.229,86.091,86.091,0,1,0,32.621,67.486,85.2,85.2,0,0,0-8.536-37.448,7.166,7.166,0,0,0-9.579-3.333Zm0,0",
    fill: "#19aacf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M183.173,64A7.176,7.176,0,0,0,176,71.173v50.213a7.176,7.176,0,0,0,7.173,7.173h35.866a7.173,7.173,0,0,0,0-14.346H190.346V71.173A7.176,7.176,0,0,0,183.173,64Zm0,0",
    transform: "translate(-97.094 -35.307)",
    fill: "#19aacf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "approval",
    d: "M215,492a20,20,0,0,1-20,20H80A80.089,80.089,0,0,1,0,432V80A80.089,80.089,0,0,1,80,0H325.891a80.092,80.092,0,0,1,80,80V292a20,20,0,0,1-40,0V80a40.047,40.047,0,0,0-40-40H80A40.047,40.047,0,0,0,40,80V432a40.047,40.047,0,0,0,40,40H195a20,20,0,0,1,20,20Zm90.891-372h-206a20,20,0,0,0,0,40h206a20,20,0,0,0,0-40Zm20,100a20,20,0,0,0-20-20h-206a20,20,0,0,0,0,40h206A20,20,0,0,0,325.891,220Zm-226,60a20,20,0,0,0,0,40H225a20,20,0,0,0,0-40Zm0,0",
    transform: "translate(363 395)",
    fill: "#19aacf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.02378efe.svg";
export { ForwardRef as ReactComponent };